import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  updateAuthenticationState,
  updateLoadingStates,
} from "../Store/Slices/authStates";
import { add } from "../Store/Slices/user";
import { USER_PROFILE_GETTER } from "../Utils/apis";

const useUserSetup = () => {
  const dispatch = useDispatch();

  return useCallback(
    async (token) => {
      dispatch(updateLoadingStates(true));

      try {
        const res = await fetch(USER_PROFILE_GETTER, {
          method: "GET",
          credentials: "include",
          // headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        if (!res.ok) {
          dispatch(updateAuthenticationState(false));
          return false;
        }

        const response = await res.json();

        if (!response?.data) {
          dispatch(updateAuthenticationState(false));
          return false;
        }

        dispatch(add(response.data));
        dispatch(updateAuthenticationState(true));
        return true;
      } catch (error) {
        console.error("Session verification failed:", error);
        dispatch(updateAuthenticationState(false));
        return false;
      }
    },
    [dispatch],
  );
};

export default useUserSetup;
